export default __webpack_public_path__ + "static/media/2002.1f850452.png";